/** @format */

export const SIDEBAR_OPEN = "SIDEBAR_OPEN";
export const SIDEBAR_CLOSE = "SIDEBAR_CLOSE";
export const LANGUAGE_TOGGLE = "LANGUAGE_TOGGLE";
export const CHOSEN_LANGUAGE = "CHOSEN_LANGUAGE";
